<template>
  <article>
    <section v-if="viewingOwnProfile && hasQuestions" class="personal-info-section box">
      <div class="header mt-1 mb-4">
        <span class="lock-image mb-3"><img src="/static/big-lock.png"></span>
        <h3 class="has-text-weight-semibold">{{$t('sectionProfile.updateResourceTitle')}}</h3>
      </div>
      <section class="questions-container" v-for="(question, index) in questions" :key="question.id">
        <div v-if="question.type === 'text'">
          <generic-input
                  v-model="answers[index].answer" :ref="question" :placeholder="question.question.replace(/([A-Z])/g, ' $1')"
                  :inputName="question.question" width="100%" :isDisabled="!editMode">
          </generic-input>
        </div>
        <div v-if="question.type === 'list'">
          <generic-dropdown
                  v-model="answers[index].optionIDs[0]" :inputName="question.question" :items="question.answers"
                  :placeholder="question.question.replace(/([A-Z])/g, ' $1')" width="100%" :isUp="index >= ((questions.length - 1) / 2)" :isDisabled="!editMode">
          </generic-dropdown>
        </div>
        <div v-if="errors[index]" id="errors-container" class="help has-text-danger error">{{errors[index]}}</div>
      </section>
      <section class="mt-2">
        <button class="button is-primary" @click="editMode ? submitAnswers(false) : editMode = true" :disabled="loadingQuestions || loading">
          <span v-if="loadingQuestions || loading" class="loader"></span>
          <span v-if="editMode">{{ $t("save")}}</span>
          <span v-if="!editMode">{{ $t("edit")}}</span>
        </button>
        <button v-if="editMode" class="button is-primary is-outlined" @click="editMode = false, fetchInternalQuestions" :disabled="loadingQuestions || loading">
          {{ $t("cancel")}}
        </button>
        <div v-if="error" class="has-text-danger help has-text-centered">{{ error }}</div>
        <div v-if="successMessage" class="has-text-primary info has-text-centered">{{ successMessage }}</div>
      </section>
    </section>
  </article>
</template>

<script>
import GenericInput from '@/components/Controls/GenericComponents/input'
import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'

import auth from '@/mixins/auth'
import resources from '@/mixins/resources'

export default {
  props: ['user'],
  components: {
    GenericInput,
    GenericDropdown
  },
  mixins: [auth, resources],
  data: function () {
    return {
      editMode: false
    }
  },
  mounted: function () {
    this.fetchInternalQuestions()
  },
  computed: {
    viewingOwnProfile: function () {
      return this.currentUser.uuid === this.user.uuid
    },
    hasQuestions: function () {
      if (this.questions?.length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    fetchInternalQuestions: function () {
      this.questions = []
      this.answers = []
      this.errors = []
      if (!this.isLoggedIn) {
        return
      }
      if (this.questions.length === 0) {
        this.loadingQuestions = true
        this.$store.dispatch('getInternalQuestions', { userID: this.$store.getters.currentUser.id }).then((response) => {
          this.questions = response.questions
          const userAnswers = response.answers
          if (this.questions) {
            this.questions.forEach((question) => {
              const newAnswer = JSON.parse(JSON.stringify(this.userAnswer))
              newAnswer.questionID = question.id
              if (userAnswers) {
                userAnswers.forEach((userAnswer) => {
                  if (userAnswer.questionID === question.id) {
                    if (question.type === 'text') {
                      newAnswer.answer = userAnswer.answer
                    } else {
                      const newOption = JSON.parse(JSON.stringify(this.option))
                      newOption.value = userAnswer.answer
                      newAnswer.optionIDs.push(newOption)
                    }
                  }
                })
              }
              this.answers.push(newAnswer)
            })
          }
          this.loadingQuestions = false
        }, () => {
          this.loadingQuestions = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .header {
    text-align: center;
    .lock-image {
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        max-width: 45px;
      }
    }
  }
  .loader {
    margin-right: 1rem;
  }
</style>
